import { Component, OnInit, Inject } from '@angular/core';
import { Globals } from '../../../globals'
import { IepService } from "../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../Models/IIepInstance'
import { IDashboardDocument } from '../../../Models/IDashboardDocument'
import { ICALPADSMeetingDelay } from '../../../Models/ICALPADSMeetingDelay'
import { CALPADSMeetingTypeEnum } from '../../../Models/Enums/CALPADSMeetingTypeEnum'
import { LookupService } from '../../../Services/LookupService';
import { ReportService } from '../../../Services/ReportService';
import { DashboardDocumentService } from '../../../Services/DashboardDocumentService';
import { LookupTypeEnum } from '../../../Models/Enums/LookupTypeEnum';
import { ILookupBase } from '../../../Models/ILookupBase';
import { IIEPStatusEvent } from '../../../Models/IIEPStatusEvent';
import { IStitchedIEPReportParameter } from '../../../Models/IStitchedIEPReportParameter';
import { IReportPDF } from '../../../Models/IReportPDF';
import { IDueDates } from '../../../Models/IDueDates';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { Message, ConfirmationService, SelectItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InitialIEPInfoService } from '../../../Services/InitialIEPInfoService';
import { IInitialIEPInfo } from '../../../Models/IInitialIEPInfo';

@Component({
  selector: 'IEPInformation',
  templateUrl: './IEPInformation.component.html',
  styleUrls: ['./IEPInformation.component.css']
})

export class IEPInformationComponent implements OnInit {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  _dashboardDocumentService: DashboardDocumentService;
  _iepInstance: IIepInstance;
  _lookupService: LookupService;
  _reportService: ReportService;
  _lookupMeetingType: ILookupBase[];
  _lookupStatus: ILookupBase[];
  _today: Date;
  _reconveneDate: Date;
  timeStamp: Date;
  _iepStatusEvents: IIEPStatusEvent[];
  _meetingIsCurrentlyConvened: boolean;
  _formsSuccessfullyValidated: boolean;
  _showMessages: boolean;
  _spinnerWhileMessage: string;
  _aeriesRefreshSpinnerMessage: string;
  _validateSpinnerMessage: string;
  showRefreshSpinner: boolean;
  _showPrintOptions: boolean;
  saveClicked: boolean;
  isOutOfCompliance: boolean = false;
  dueDates: IDueDates;
  calendarYearRangeTriennial: string;
  _partBInitialMeetingDelayArray: ICALPADSMeetingDelay[];
  //_partCInitialMeetingDelayArray: ICALPADSMeetingDelay[];
  _annualMeetingDelayArray: ICALPADSMeetingDelay[];
  _pendingMeetingDelayArray: ICALPADSMeetingDelay[];
  _triennialMeetingDelayArray: ICALPADSMeetingDelay[];
  _meetingDelayArray: ICALPADSMeetingDelay[];
  allIepPrintFormsList: ILookupBase[] = [];
  selectedIepPrintForms: ILookupBase[];
  selectedMeetingDelay: ICALPADSMeetingDelay;
  minAnnualDueDate: Date;
  maxAnnualDueDate: Date;
  minTriDueDate: Date;
  maxTriDueDate: Date;

  successMessages: Message[];
  errorMessages: Message[];

  constructor
    (
      private globals: Globals,
      iepService: IepService,
      lookupService: LookupService,
      reportService: ReportService,
      dashboardDocumentService: DashboardDocumentService,
      private confirmationService: ConfirmationService,
      private _initialIepInfoService: InitialIEPInfoService,
      @Inject('BASE_URL') baseUrl: string) {
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._dashboardDocumentService = dashboardDocumentService;
    this._today = new Date();
    this._reconveneDate = null;
    this._showMessages = false;
  }

  ngOnInit(): void {
    this._iepInstance = this._myGlobals.selectedIepInstance;
    this._iepInstance.meetingId = this._iepInstance.meetingId.toString();
    this._formsSuccessfullyValidated = false;
    this._showPrintOptions = false;
    this._aeriesRefreshSpinnerMessage = ' while student demographics and contact(s) are refreshed from Aeries';
    this._validateSpinnerMessage = ' while the IEP forms are validated';
    this.RefreshIEPStatusEvents();
    this.LoadLookupValues();
    this.getPrintIepForms();
    let today = new Date();
    this.calendarYearRangeTriennial = today.getFullYear() + ':' + (today.getFullYear() + 3);

    this._dashboardDocumentService.getDueDates(this._myGlobals.selectedStudent.localStudentId).subscribe((res: IDueDates) => {
      this.dueDates = res as IDueDates;
      this.adjustMinMaxForDueDates();
    },
      err => console.error(err)
    );
  }

  RefreshIEPStatusEvents() {
    this._iepService.getIepStatusEvents(this._baseUrl + 'api/IEP/GetIepStatusEventList?iepInstanceId=' + this._iepInstance.id).subscribe((res: IIEPStatusEvent[]) => {
      this._iepStatusEvents = res;
    },
      err => console.error(err)
    );
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.MeetingTypeNew]).subscribe((res: ILookupBase[]) => {
      this._lookupMeetingType = [] as ILookupBase[];
      this._lookupMeetingType.push({ label: 'Select a Meeting Type', value: null, shortText: 'Select a Meeting Type', updatedOn: null });
      this._lookupMeetingType.push.apply(this._lookupMeetingType, res);
    },
      err => console.error(err)
    );

    // PartBInitial
    this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.PartBInitial]).subscribe((res: ICALPADSMeetingDelay[]) => {
      this._partBInitialMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
      this.manageDelayCodes();
    },
      err => console.error(err)
    );

    //// PartCInitial
    //this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.PartCInitial]).subscribe((res: ICALPADSMeetingDelay[]) => {
    //  this._partCInitialMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
    //},
    //  err => console.error(err)
    //);

    // AnnualIEP
    this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.AnnualIEP]).subscribe((res: ICALPADSMeetingDelay[]) => {
      this._annualMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
      this.manageDelayCodes();
    },
      err => console.error(err)
    );

    // Pending
    this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.Pending]).subscribe((res: ICALPADSMeetingDelay[]) => {
      this._pendingMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
      this.manageDelayCodes();
    },
      err => console.error(err)
    );

    // TriennialEvaluationIep
    this._lookupService.getCALPADSMeetingDelayList(CALPADSMeetingTypeEnum[CALPADSMeetingTypeEnum.TriennialEvaluationIep]).subscribe((res: ICALPADSMeetingDelay[]) => {
      this._triennialMeetingDelayArray = [{ id: null, text: "[Select One]", shortText: "[Select One]", is10PartBInitial: null, is15PartCInitial: null, is20AnnualIEP: null, is30Pending: null, is40TriennialEvaluationIep: null }].concat(res) as ICALPADSMeetingDelay[];
      this.manageDelayCodes();
    },
      err => console.error(err)
    );

  }

  RefreshStudentDemographicsAndContactsData() {
    this.controlSpinner(true, this._aeriesRefreshSpinnerMessage);
    this._dashboardDocumentService.refreshIEPSpedStudentDemographicsAndContactsFromAeries(this._iepInstance.id).subscribe((res: ISpedStudentDemographics) => {
      this.controlSpinner(false, '');
    },
      err => {
        console.error(err);
        this.controlSpinner(false, '');
      }
    );
  }

  ReconveneDateSelected() {
    this.clearMessages();
    this.timeStamp = new Date();
    this._iepService.insertUpdateIepInstance(this._iepInstance).subscribe((res: IIepInstance) => {
      this._myGlobals.selectedIepInstance = res;
      this._iepInstance = this._myGlobals.selectedIepInstance;
      let successMessage: Message = { severity: 'success', summary: 'Reconvene Date Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
    },
      err => {
        console.error(err);
      }
    );
  }

  ValidateForms() {
    this.clearMessages();
    //this._iepInstance = this._myGlobals.selectedIepInstance;
    this.controlSpinner(true, this._validateSpinnerMessage);

    this._iepService.validateForms(this._iepInstance).subscribe((res: string[]) => {
      let errorMessages: string[] = res as string[];
      if (errorMessages.length == 0) {
        this._formsSuccessfullyValidated = true;
        let successMessage: Message = { severity: 'success', summary: 'All Forms Validated with zero errors', detail: '' }
        this.addMessage(successMessage);
        this.RefreshIepInstance(this._iepInstance.id);
      }
      else {
        for (var message of errorMessages) {
          let errorMessage: Message = { severity: 'error', summary: 'Form Failed Validation - Please Correct Error:', detail: message}
          this.addMessage(errorMessage);
        }
      }
      this.controlSpinner(false, '');
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'An unexpected error has occurred: ', detail: err }
        this.addMessage(errorMessage);
        this.controlSpinner(false, '');
      }
    );
  }
  OnConveneMeetingClicked()
  {
    if (this._iepInstance.annualDueDate && this._iepInstance.meetingDate) {
      let cutoffDate = new Date(this._iepInstance.meetingDate);
      cutoffDate.setDate(cutoffDate.getDate() + 30);
      if (this._iepInstance.annualDueDate < cutoffDate) {
        this.confirmationService.confirm({
          message: 'Next Annual Due Date is less than 30 days from Meeting Date. Are you sure you wish to proceed?',
          accept: () => {
            this.ConveneMeeting();
          },
          reject: () => { }
        });
      }
      else {
        this.ConveneMeeting();
      }
    }
    else if (this._iepInstance.meetingDate) {
      this.ConveneMeeting();
    }
  }
  ConveneMeeting() {
    this.clearMessages();
    if (this.validateConvene()) {
      this._iepService.conveneMeeting(this._iepInstance).subscribe((res: string[]) => {
        let errorMessages: string[] = res as string[];
        if (errorMessages.length == 0) {
          this._meetingIsCurrentlyConvened = true;
          let successMessage: Message = { severity: 'success', summary: 'Meeting Successfully Convened', detail: '' }
          this.addMessage(successMessage);
          this.RefreshIepInstance(this._iepInstance.id);
          this.RefreshIEPStatusEvents();

          this.RefreshDocumentDashboard();
        }
        else {
          for (var msg in errorMessages) {
            let errorMessage: Message = { severity: 'error', summary: 'Meeting Not Convened - Please Correct Error:', detail: msg }
            this.addMessage(errorMessage);
          }
        }

      },
        err => {
          console.error(err);
          let errorMessage: Message = { severity: 'error', summary: 'An unexpected error has occurred: ', detail: err }
          this.addMessage(errorMessage);
        }
      );
    }
  }

  validateConvene(): boolean {
    let isValid = true;
    let today = new Date();
    let lateToday = new Date();
    lateToday.setDate(lateToday.getDate() + 1);
    lateToday.setHours(0, 0, 0, 0);
    lateToday.setMilliseconds(lateToday.getMilliseconds()-1);

    if (this._iepInstance.meetingDate && this._iepInstance.meetingDate > lateToday) {
      isValid = false;
      let errorMessage: Message = { severity: 'error', summary: 'Validation Error: ', detail: 'Meeting Date cannot be in the future when convening a meeting' }
      this.addMessage(errorMessage);
    }
    return isValid;
  }

  RefreshIepInstance(iepInstanceId: number) {
    this._iepService.getIepInstance(this._baseUrl + 'api/Iep/GetIepInstance?iepInstanceId=' + iepInstanceId).subscribe((res: IIepInstance) => {
      this._iepInstance = res as IIepInstance
      this._iepInstance.meetingId = this._iepInstance.meetingId.toString();

      if (this._iepInstance != null) {
        this._iepInstance.addendumDate = this._iepInstance.addendumDate == null ? null : new Date(this._iepInstance.addendumDate);
        this._iepInstance.annualDueDate = this._iepInstance.annualDueDate == null ? (this.dueDates.annualDueDate == null ? null : this.dueDates.annualDueDate) : new Date(this._iepInstance.annualDueDate);
        this._iepInstance.meetingDate = this._iepInstance.meetingDate == null ? null : new Date(this._iepInstance.meetingDate);
        this._iepInstance.nextReconveneDate = this._iepInstance.nextReconveneDate == null ? null : new Date(this._iepInstance.nextReconveneDate);
        this._iepInstance.printedDate = this._iepInstance.printedDate == null ? null : new Date(this._iepInstance.printedDate);
        this._iepInstance.triAnnualDueDate = this._iepInstance.triAnnualDueDate == null ? (this.dueDates.triAnnualDueDate == null ? null : this.dueDates.triAnnualDueDate) : new Date(this._iepInstance.triAnnualDueDate);
        this._iepInstance.validatedDate = this._iepInstance.validatedDate == null ? null : new Date(this._iepInstance.validatedDate);
        this._iepInstance.meetingId = this._iepInstance.meetingId.toString();
      }
      this._myGlobals.selectedIepInstance = this._iepInstance;
      this.RefreshIEPStatusEvents();
      this.getPrintIepForms();
      this.RefreshDocumentDashboard();
    },
      err => console.error(err)
    );
  }

  ReConveneMeeting() {
    this.clearMessages();

    this._iepService.reConveneMeeting(this._iepInstance).subscribe((res: IIepInstance) => {
      this._iepInstance = res as IIepInstance;
      this._iepInstance.meetingId = this._iepInstance.meetingId.toString();
      this._myGlobals.selectedIepInstance = res as IIepInstance;
      this._meetingIsCurrentlyConvened = true;
      let successMessage: Message = { severity: 'success', summary: 'Meeting Successfully Re-Convened', detail: res.id.toString() }
      this.addMessage(successMessage);
      this.RefreshIepInstance(this._iepInstance.id);
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'An unexpected error has occurred: ', detail: err }
        this.addMessage(errorMessage);
      }
    );
  }
  OnGoToPrintSignatureClicked() {
    if (this._iepInstance.annualDueDate && this._iepInstance.meetingDate) {
      let cutoffDate = new Date(this._iepInstance.meetingDate);
      cutoffDate.setDate(cutoffDate.getDate() + 30);
      if (this._iepInstance.annualDueDate < cutoffDate) {
        this.confirmationService.confirm({
          message: 'Next Annual Due Date is less than 30 days from Meeting Date. Are you sure you wish to proceed?',
          accept: () => {
            this.GoToPrintSignature();
          },
          reject: () => { }
        });
      }
      else {
        this.GoToPrintSignature();
      }
    }
    else {
      //annual due date is null; it can be null for a good reason (ineligible/exit)
      //validation handled by ValidateForms button
      this.GoToPrintSignature();
    }
   }

  GoToPrintSignature() {
    this.clearMessages();

    this._iepService.goToPrintSignature(this._iepInstance).subscribe((res: IIepInstance) => {
      this._iepInstance = res as IIepInstance;
      this._iepInstance.meetingId = this._iepInstance.meetingId.toString();
      this._myGlobals.selectedIepInstance = res as IIepInstance;
      let successMessage: Message = { severity: 'success', summary: 'Meeting Status Successfully changed to Print Signature', detail: res.id.toString() }
      this.addMessage(successMessage);
      this.RefreshIepInstance(this._iepInstance.id);

      this.RefreshDocumentDashboard();
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'An unexpected error has occurred: ', detail: err }
        this.addMessage(errorMessage);
      }
    );
  }

  GoToOfficial() {
    this.clearMessages();

    this._iepService.goToOfficial(this._iepInstance).subscribe((res: IIepInstance) => {
      this._iepInstance = res as IIepInstance;
      this._iepInstance.meetingId = this._iepInstance.meetingId.toString();
      this._myGlobals.selectedIepInstance = res as IIepInstance;
      let successMessage: Message = { severity: 'success', summary: 'Meeting Status Successfully changed to Official', detail: res.id.toString() }
      this.addMessage(successMessage);
      this.RefreshIepInstance(this._iepInstance.id);

      this.RefreshDocumentDashboard();
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'An unexpected error has occurred: ', detail: err }
        this.addMessage(errorMessage);
      }
    );
  }

  onGoToOfficialClicked() {
    this.clearMessages();
    let isValid: boolean = true;

    this._initialIepInfoService.getInitialIEPInfo(this._myGlobals.selectedStudent.localStudentId).subscribe(
      (info: IInitialIEPInfo) => {
        if (info.identifiedAsSPEDDate == null) {
          isValid = false;
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error: ', detail: 'Initial Referral Date is required in Initial Iep Info' }
          this.addMessage(errorMessage);
        }

        if (info.initialConsentDate == null) {
          isValid = false;
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error: ', detail: 'Initial PTA Received Date is required in Initial Iep Info' }
          this.addMessage(errorMessage);
        }

        if (info.initialIepDate == null) {
          isValid = false;
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error: ', detail: 'Initial IEP Date is required in Initial Iep Info' }
          this.addMessage(errorMessage);
        }

        if (info.spedEntryDate == null) {
          isValid = false;
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error: ', detail: 'SPED entry Date is required in Initial Iep Info' }
          this.addMessage(errorMessage);
        }

        if (info.initialEvalDate == null) {
          isValid = false;
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error: ', detail: 'Initial Eval Date is required in Initial Iep Info' }
          this.addMessage(errorMessage);
        }

        if (info.lastEvalDate == null) {
          isValid = false;
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error: ', detail: 'Last Eval Date is required in Initial Iep Info' }
          this.addMessage(errorMessage);
        }

        if (info.spedIdentifierDescription == null) {
          isValid = false;
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error: ', detail: 'Referred By is required in Initial Iep Info' }
          this.addMessage(errorMessage);
        }

        if (isValid) {
          this.GoToOfficial();
        }
      },
      (err) => {
        isValid = false;
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'An error has occurred when retrieving Initial IEP info: ', detail: err }
        this.addMessage(errorMessage);

        return isValid;
      }
    )
  }

  cancelIep() {
    this.clearMessages();

    this._iepService.goToCancelled(this._iepInstance).subscribe((res: IIepInstance) => {
      this._iepInstance = res as IIepInstance;
      this._iepInstance.meetingId = this._iepInstance.meetingId.toString();
      this._myGlobals.selectedIepInstance = res as IIepInstance;
      let successMessage: Message = { severity: 'success', summary: 'Meeting Status Successfully changed to Cancelled', detail: res.id.toString() }
      this.addMessage(successMessage);
      this.RefreshIepInstance(this._iepInstance.id);

      this.RefreshDocumentDashboard();
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'An unexpected error has occurred: ', detail: err }
        this.addMessage(errorMessage);
      }
    );
  }

  onCancelIepClicked() {
    this.confirmationService.confirm(
      {
        message: 'Are you sure you wish to cancel this IEP',
        accept: () => { this.cancelIep(); }
      }
    );
  }

  RefreshDocumentDashboard() {
    this._dashboardDocumentService.get(this._baseUrl + 'api/DashboardDocument/' + this._myGlobals.selectedStudent.localStudentId).subscribe((res: IDashboardDocument[]) => {
      this._myGlobals.dashboardDocumentResults = res
        , console.log(this._myGlobals.dashboardDocumentResults);
    },
      err => console.error(err)
    );
  }

  GoBackToMeetingInProgress() {
    this._iepInstance.statusId = 5;
    this.save('Close');
  }

  controlSpinner(visible: boolean, spinnerWhileMessage: string) {
    this.showRefreshSpinner = visible;
    this._spinnerWhileMessage = spinnerWhileMessage;
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  getPrintIepForms() {
    this._iepService.getPrintIepForms(this._iepInstance.id).subscribe((res: ILookupBase[]) => {
      this.allIepPrintFormsList = res as ILookupBase[];
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'An unexpected error has occurred: ', detail: err }
        this.addMessage(errorMessage);
      }
    );
  }

  enterEditMode() {
    this._myGlobals.editMode = true;
    this.saveClicked = false;
  }

  //Save 
  save(action) {
    this.clearMessages();
    this.saveClicked = true;

    if (this._iepInstance.statusId == 1) {

      if (this._iepInstance.previousAnnualDueDate == null) {
        this._iepInstance.previousAnnualDueDate = this.dueDates.annualDueDate;
      }

      if (this._iepInstance.previousTriennialDueDate == null) {
        this._iepInstance.previousTriennialDueDate = this.dueDates.triAnnualDueDate;
      }
    }

    this.timeStamp = new Date();

    this._iepService.insertUpdateIepInstance(this._iepInstance).subscribe((res: IIepInstance) => {
      this._myGlobals.selectedIepInstance = res as IIepInstance;
      this._iepInstance = res as IIepInstance;
      this._iepInstance.meetingId = this._iepInstance.meetingId.toString();
      let successMessage: Message = { severity: 'success', summary: 'IEP Information Successfully Updated.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
      if (action == 'Close') {
        this._myGlobals.editMode = false;
      }
      this.saveClicked = false
      this.ValidateForms();
      this.manageDelayCodes();
      this.RefreshDocumentDashboard();
    },
      err => {
        console.error(err);
        this.saveClicked = false
      }
    );
  }

  delayCodeChanged() {
    if (this.selectedMeetingDelay == null) {
      this._iepInstance.meetingDelayCode = null;
    }
    else {
      this._iepInstance.meetingDelayCode = this.selectedMeetingDelay.id;
    }
  }

  meetingTypeChanged() {
    this.selectedMeetingDelay = null;
    this._iepInstance.meetingDelayCode = null;
    this.adjustMinMaxForDueDates();
  }

  adjustMinMaxForDueDates() {
    let mtgDate = this._iepInstance.meetingDate;
    this.maxAnnualDueDate = this.dueDates?.annualDueDate
    this.maxTriDueDate = this.dueDates?.triAnnualDueDate;

    switch (this._iepInstance.meetingId) {
      case '1': // Initial
        this.maxAnnualDueDate = new Date(mtgDate.getFullYear() + 1, mtgDate.getMonth(), mtgDate.getDate() - 1);
        this.maxTriDueDate = new Date(mtgDate.getFullYear() + 3, mtgDate.getMonth(), mtgDate.getDate() - 3);
        break;
      case '2': // Annual
        if (this._iepInstance.meetingDelayCode != null) {
          this.maxAnnualDueDate = new Date(mtgDate.getFullYear() + 1, mtgDate.getMonth(), mtgDate.getDate() - 1);
        }
        break;
      case '3': // Triennial
        if (this._iepInstance.meetingDelayCode != null) {
          this.maxAnnualDueDate = new Date(mtgDate.getFullYear() + 1, mtgDate.getMonth(), mtgDate.getDate() - 1);
          this.maxTriDueDate = new Date(mtgDate.getFullYear() + 3, mtgDate.getMonth(), mtgDate.getDate() - 3);
        }
        break;
      // There is no code for a 30 Day because it does not change either the Annual or the Tri due dates
      //case '6': // 30 Day

      //  break;
    }
  }

  manageDelayCodes() {
    this.isOutOfCompliance = false;

    let meetingId = +this._iepInstance.meetingId;

    if ((this._iepInstance.statusId == 1 || this._iepInstance.statusId == 5) && meetingId <= 3) {
      switch (this._iepInstance.meetingId) {
        case "1": // Initial
          this._meetingDelayArray = this._partBInitialMeetingDelayArray;
          if (this.dueDates == null || this.dueDates.initialDueDate == null) {
            this.isOutOfCompliance = false;
            break;
          }
          if (new Date(this._iepInstance.meetingDate) > new Date(this.dueDates.initialDueDate)) {
            this.isOutOfCompliance = true;
          }
          break;
        case "2": // Annual
          this._meetingDelayArray = this._annualMeetingDelayArray;
          if (new Date(this._iepInstance.meetingDate) > new Date(this._iepInstance.previousAnnualDueDate)) {
            this.isOutOfCompliance = true;
          }
          break;
        case "3": // Triennial
          this._meetingDelayArray = this._triennialMeetingDelayArray;
          if (new Date(this._iepInstance.meetingDate) > new Date(this._iepInstance.previousAnnualDueDate)) {
            this.isOutOfCompliance = true;
          }
          break;
        case "6": //30 day
          this._meetingDelayArray = this._annualMeetingDelayArray;
          //check with SELPA if need new rules here
          break;
      }

      if (this._meetingDelayArray != null && this._iepInstance.meetingDelayCode != null) {
        this.selectedMeetingDelay = this._meetingDelayArray.find(x => x.id == this._iepInstance.meetingDelayCode);;
      }
    }
  }

  cancel() {
    this.clearMessages();
    this._myGlobals.editMode = false;
    this.RefreshIepInstance(this._iepInstance.id);
  }

  showPrintOptions() {
    this._showPrintOptions = true;
  }

  hidePrintOptions() {
    this._showPrintOptions = false;
  }

  printBlankIepForms() {
    this._spinnerWhileMessage = 'while the IEP PDF forms are generated and combined.';
    this.showRefreshSpinner = true;

    this._reportService.getBlankIepPdfReport().subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showRefreshSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
    },
      err => {
        this.showRefreshSpinner = false;
        console.error(err);
      }
    );
  }

  printIepForms(selectedForms: boolean, inEnglish: boolean){
    var stitchedIEPReportParameter = {} as IStitchedIEPReportParameter;
    stitchedIEPReportParameter.iepInstanceId = this._myGlobals.selectedIepInstance.id;
    stitchedIEPReportParameter.isSpanish = !inEnglish;

    if (selectedForms) {
      var formInstanceIdArray = new Array<number>(this.selectedIepPrintForms.length);

      for (var i = 0; i < this.selectedIepPrintForms.length; i++) {
        formInstanceIdArray[i] = Number.parseInt(this.selectedIepPrintForms[i].value);
      } 
      stitchedIEPReportParameter.limitToSpecificFormInstanceIdArray = formInstanceIdArray;
    } else {
      stitchedIEPReportParameter.limitToSpecificFormInstanceIdArray = null;
    }

    this._spinnerWhileMessage = 'while the IEP PDF forms are generated and combined.';
    this.showRefreshSpinner = true;

    this._reportService.getIepStitchedPdfReport(stitchedIEPReportParameter).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }  
      this.showRefreshSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), res.fileName);
    },
      err => {
        this.showRefreshSpinner = false;
        console.error(err);
      }
    );

  }

  onAnnualDueDateChanged() {
    if (this._iepInstance.annualDueDate && this._iepInstance.meetingDate) {
      let cutoffDate = new Date(this._iepInstance.meetingDate);
      cutoffDate.setDate(cutoffDate.getDate() + 30);

      if (this._iepInstance.annualDueDate < cutoffDate) {
        this.confirmationService.confirm({
          message: 'Next Annual Due Date is less than 30 days from Meeting Date.',
          rejectVisible: false,
          acceptVisible: true,
          acceptLabel: 'Ok'
        })
      }
    }
  }
}
